// redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import configReducer from './slices/configSlice'; // Import the config slice
import playersReducer from './slices/playersSlice';
import userReducer from './slices/userSlice';
import chatReducer from './slices/chatSlice';
import pageReducer from './slices/pageSlice';
import engagementReducer from './slices/engagementSlice';
import { useDispatch } from 'react-redux';

const store = configureStore({
    reducer: {
        config: configReducer,
        players: playersReducer,
        user: userReducer,
        chat: chatReducer,
        page: pageReducer,
        engagement:engagementReducer
    },
});

// Define RootState type from the store’s state
export type RootState = ReturnType<typeof store.getState>;

// Export a type for `AppDispatch` which will infer the correct type for `dispatch`
export type AppDispatch = typeof store.dispatch;


// Create a typed useDispatch hook
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
